<template>
  <Modal
    class-name="insu-prod-details-modal"
    :value="value"
    :width="930"
    @on-cancel="cancel"
  >
    <div v-if="details">
      <div class="clearfix mb-s insu-prod-premiums">
        <h2 class="title section-title">{{ `${details.insuCompany} ${details.insuName}` }}</h2>
        <div class="pull-right premiums-right">
          <span class="premiums">{{ `${details.premiums} 元` }}</span>
          <Button
            size="large"
            class="btn-m btn-primary"
            @click="handlePurchase(details)"
          >
            <span>
              <Icon 
                type="android-cart"
                :style="{paddingRight: '10px'}"
              />購買
            </span>
          </Button>
        </div>
      </div>
      <!-- modal header end -->
      <div class="insu-prod-details">
        <InsuProdDetailList 
          v-for="(data, i) in details.lists"
          :key="i"
          :data="data"
        />
      </div>
      <InsuProdPolicies :prodPolicies="details.prodPolicies" />
    </div>
    <div slot="footer" />
  </Modal>
</template>

<script>
  import { Modal, Button, Icon } from 'iview';
  import InsuProdDetailList from '@/components/insurance/InsuProdDetailList';
  import InsuProdPolicies from '@/components/insurance/InsuProdPolicies';

  export default {
    components: { Modal, InsuProdDetailList, InsuProdPolicies, Button, Icon },
    props: {
      details: {
        type: Object,
        default: null
      },
      value: {
        type: Boolean,
        default: false
      },
      handlePurchase: {
        type: Function,
        default: () => {}
      }
    },
    beforeDestroy() {
      document.body.style.overflow = 'initial';
    },
    methods: {
      cancel() {
        this.$emit('input', false);
      },
    }
  };
</script>